import { z } from 'zod'
import { Option } from '~/shared/config/constants'
import { stringRequiredScheme, uuidOptionSchema } from '~/shared/lib/schemas'

export const formSchema = z.object({
  regionId: uuidOptionSchema,
  dispatcher: stringRequiredScheme,
  controller: stringRequiredScheme,
  doctor: stringRequiredScheme,
})

export type TypeFormSchema = z.infer<typeof formSchema>

export type FormValues = Omit<TypeFormSchema, 'regionId'> & {
  regionId: UniqueId | Option
}
